import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function DeploymentLocationDetails() {
    const navigate = useNavigate();
    const location = useLocation();
    const locationDetails = location.state?.locationDetails || {};

    return (
        <div>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className='row text-end'>
                                <div className='col'>
                                    <button type="button" class="btn btn-danger"
                                        style={{
                                            backgroundColor: "rgb(236, 17, 23)"
                                        }}
                                        onClick={() => navigate("/deployment-location-master")}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                            <h4 style={{ display: "flex", marginBottom: "30px" }}>
                                Deployment Location Details of :  {locationDetails.location_name}
                            </h4>
                            <div className="card">
                                <div className="p-3">
                                    <div className="text-start mb-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Location Name</label>
                                                    <input
                                                        type="text"
                                                        name="location_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.location_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Zone</label>
                                                    <input
                                                        type="text"
                                                        name="zone_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.zone_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Circle</label>
                                                    <input
                                                        type="text"
                                                        name="circle_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.circle_name}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Ward</label>
                                                    <input
                                                        type="text"
                                                        name="ward_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.ward_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Collection Type</label>
                                                    <input
                                                        type="text"
                                                        name="collection_type_id"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.collection_type_id}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Radius</label>
                                                    <input
                                                        type="text"
                                                        name="radius"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.radius}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">LandMark</label>
                                                    <input
                                                        type="text"
                                                        name="landmark"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.landmark}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Latitude</label>
                                                    <input
                                                        type="text"
                                                        name="latitude"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.latitude}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Longitude</label>
                                                    <input
                                                        type="text"
                                                        name="longitude"
                                                        className="form-control"
                                                        readOnly
                                                        value={locationDetails.longitude}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="status"
                                                        readOnly
                                                        value={locationDetails.status === "1" ? "Active" : "Inactive"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeploymentLocationDetails
